import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";

const ScheduleInternalMultiApprovalDeclined = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [rejectedTransactions, setRejectedTransactions] = useState([]);

  useEffect(() => {
    dispatch(disableSwitcher());
    dispatch(setHideBreadCrumb({ hide: true }));

    try {
      const storedData = JSON.parse(
        sessionStorage.getItem("intSelectedScheduleCard") || "[]",
      );

      const selectedDetails = storedData?.[0]?.selectedDetails;

      setRejectedTransactions(
        Array.isArray(selectedDetails) ? selectedDetails : [],
      );
    } catch (error) {
      console.error("Failed to load rejected schedules:", error);
      setRejectedTransactions([]);
    }

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const goToDashboard = () => {
    navigate("/internal_transaction_dashboard");
  };

  const rejectMoreSchedules = () => {
    navigate("/internal_transaction_dashboard/schedule_multi_approval");
  };

  const buttonRows = [
    [
      {
        btnText: "Reject more schedules",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: rejectMoreSchedules,
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const RejectedScheduleList = ({ transactions }) => (
    <div className="flex flex-col">
      {transactions.map((transaction) => {
        if (!transaction?.txn_id) return null;

        const scheduleDetailPath = `/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/${transaction.txn_id}`;

        return (
          <InfoCard
            key={transaction.txn_id}
            bgColor="var(--positive-card)"
            hoverable="white"
            onClick={() => navigate(scheduleDetailPath)}
            rows={[
              {
                leftTitle: transaction?.scheduled_name,
                leftSubTitle: "Schedule name",
                rightTitle: (
                  <>
                    INR <FormatAmount price={transaction?.amount} />
                  </>
                ),
                rightSubTitle: "Amount",
                rightTextFontWeight: "semibold",
                rightTitleTextColor: "var(--text-primary)",
                hasRight: true,
                rightIcon: true,
                rightText: true,
                onClick: () => navigate(scheduleDetailPath),
              },
            ]}
          />
        );
      })}
    </div>
  );

  return (
    <StatusContainer
      status="success"
      title={rejectedTransactions.length && "Schedules rejected successfully."}
      buttonRows={buttonRows}
    >
      <TabsWeapperSection
        title={`Rejected schedules - ${rejectedTransactions.length}`}
      >
        <RejectedScheduleList transactions={rejectedTransactions} />
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default ScheduleInternalMultiApprovalDeclined;
